import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { ArrowDownIcon } from '@icons';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import classes from './QuestionsItem.module.scss';
import ListItem from '@shared/ListItem/ListItem';
import Markdown from 'react-markdown/with-html';
const QuestionsItem = ({ item: { question, answer } }) => {
    const [isOpened, setOpened] = useState(false);
    return (_jsx(ListItem, { type: "li", className: classNames(classes.item, { [classes.opened]: isOpened }), children: _jsxs(_Fragment, { children: [_jsxs("button", { className: classes.question, onClick: () => setOpened(!isOpened), children: [_jsx("div", { className: classes.text, children: question }), _jsx(ArrowDownIcon, { containerClasses: classes.svg })] }), _jsx(AnimateHeight, { duration: 400, height: isOpened ? 'auto' : 0, children: _jsx(Markdown, { className: classes.answer, allowDangerousHtml: true, children: answer }) })] }) }));
};
export default QuestionsItem;
